import { logError } from 'utils/logger';
import { useMutation } from '@apollo/client';
import { useNotifications } from 'modules/notification';
import { CreateStageNoteResponse, CreateStageNoteVariables, bpfAPI } from '../index';

export function useBPFStages() {
  const { showNotification } = useNotifications();

  const [onCreateStageNote, { loading: isNoteCreating }] = useMutation<
    CreateStageNoteResponse,
    CreateStageNoteVariables
  >(bpfAPI.createStageNote);

  const handleCreateStageNote = async (dto: CreateStageNoteVariables['input']) => {
    try {
      const { data, errors } = await onCreateStageNote({ variables: { input: dto } });

      if (errors?.length || data?.bpf?.result?.error || !data?.bpf?.result?.success) {
        logError('handleCreateCloseReasons error');
        showNotification(data?.bpf?.result?.error ?? 'Something went wrong', { type: 'error' });
        return null;
      }

      showNotification('Note created successfully.');

      return data.bpf.result.entity;
    } catch (error) {
      showNotification('Something went wrong', { type: 'error' });
      logError(error);
      return null;
    }
  };

  return {
    isNoteCreating,
    handleCreateStageNote,
  };
}
